import { PageState } from 'models/PageState';

export const getNumberOfFavourites = (state: PageState) => state.favourites.productIds?.length ?? 0;
